import React from "react";
import { useForm } from "react-hook-form";
import CustomSelect from "Components/CommonComponents/CustomSelect";
import Typography from "Components/CommonComponents/Typography";
import styled from "styled-components";

const DivSelectLimit = styled<any>("div")`
  z-index: 9 !important;
  width: ${(props: any) =>
    ["xxl", "xl", "lg"].includes(props.screen) ? "150px" : "65px"}};
    left: ;
`;
const PaginationLimit = (props: any) => {
  const { screen } = props;
  const { control } = useForm();
  return (
    <div className="itemPerPageRow">
      <DivSelectLimit screen={screen}>
        <CustomSelect
          width={["xxl", "xl", "lg"].includes(screen) ? "85px" : "65px"}
          defaultValue={props.limitValue}
          onChange={props.onLimitChange}
          controlName={control}
          name={"customname"}
          menuPlacement={"top"}
          options={props.ItemPerPageArray}
          infoIcon={true}
          toolTipData={"Limit of per page"}
        />
      </DivSelectLimit>
      <div className="itemPerPageStyle">
        <Typography variant="body3" color="gray-n">
          {["xxl", "xl", "lg"].includes(screen)
            ? "Items per page"
            : "Items/page"}
        </Typography>
      </div>
      {["xxl", "xl", "lg"].includes(screen) ? (
        <div className="perPageDataInfoStyle">
          <Typography variant="body3" color="gray-n">
            {props.pagination.currentPage * props.limit +
              1 +
              "-" +
              (props.pagination.nextPage
                ? props.pagination.nextPage * props.limit
                : props.pagination.totalCount == undefined
                ? props.totalCount
                : props.pagination.totalCount) +
              " of " +
              props.totalCount +
              " items"}
          </Typography>
        </div>
      ) : null}
    </div>
  );
};
export default PaginationLimit;
